import React from "react";
import { Button, Form, Stack } from "react-bootstrap";
import { useWorkOrders } from "../../../data/WorkOrdersHook";

function CustomerDetails() {
  const workOrdersRepository = useWorkOrders();

  const copyFromReporter = () => {
    const current = workOrdersRepository.getEntry();
    const revised = {
      ...current,
      customername: current.reportername,
      customeremail: current.reporteremail,
      customerphone: current.reportertelephone,
    };
    workOrdersRepository.setEntry(revised);
  };

  const updateCustomerVulnerability = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, customervulnerability: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const updateCustomerName = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, customername: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const updateCustomerPhone = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, customerphone: e.target.value };
    workOrdersRepository.setEntry(revised);
  };
  const updateCustomerEmail = (e) => {
    const current = workOrdersRepository.getEntry();
    const revised = { ...current, customeremail: e.target.value };
    workOrdersRepository.setEntry(revised);
  };

  const workOrder = workOrdersRepository.getEntry();

  return (
    <div className="work-order-entry-section customer-details">
      <Stack direction="horizontal">
        <h3>Customer Details</h3>
        {workOrder.reportertype === "Resident" && (
          <Button
            className="ms-auto"
            variant="secondary"
            onClick={copyFromReporter}
          >
            Copy Reporter Details
          </Button>
        )}
      </Stack>
      <Form.Group className="mb-3" controlId="customerNameGroup">
        <Form.Label>Customer Name</Form.Label>
        <Form.Control
          required
          as="input"
          type="text"
          value={workOrder.customername}
          onChange={updateCustomerName}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="customerEmailGroup">
        <Form.Label>Customer Email</Form.Label>
        <Form.Control
          as="input"
          type="email"
          value={workOrder.customeremail}
          onChange={updateCustomerEmail}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="customerPhoneNumberGroup">
        <Form.Label>Customer Phone Number</Form.Label>
        <Form.Control
          required
          as="input"
          value={workOrder.customerphone}
          onChange={updateCustomerPhone}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="customervulnerabilityGroup">
        <Form.Label>Customer Vulnerability Notes</Form.Label>
        <Form.Control
          as="textarea"
          rows={6}
          value={workOrder.customervulnerability}
          onChange={updateCustomerVulnerability}
        />
      </Form.Group>
    </div>
  );
}

export default CustomerDetails;
